<template>
  <div class="dashboard-page">
    <header class="dashboard-header">
      <div class="circuit circuit-header" aria-hidden="true"></div>
      <div class="header-content">
        <div class="brand">
          <img src="/static/img/logo/open-house-2026.png" alt="RMUTL Open House">
          <div class="brand-copy">
            <strong>RMUTL Open House</strong>
            <small>เปิดบ้านราชมงคลล้านนา รายงานสรุปจำนวนผู้เข้าร่วม Open House
            </small>
          </div>
        </div>
        <div class="date-picker" role="button" tabindex="0" @click="openDatePicker"
          @keydown.enter.prevent="openDatePicker" @keydown.space.prevent="openDatePicker">
          <span>{{ displayDate }}</span>
          <i class="ti ti-calendar"></i>
          <input ref="dateInput" type="date" v-model="dateNow" @change="getDashboard()" @click.stop>
        </div>
      </div>
    </header>

    <main class="dashboard-content">
      <section class="summary-grid">
        <article v-for="card in summaryCards" :key="card.key" :class="['summary-card', card.variant]">
          <img class="summary-card-art" :src="card.image" alt="" aria-hidden="true">
          <div class="summary-icon">
            <img :src="card.image" :alt="card.label">
          </div>
          <div class="summary-copy">
            <div class="summary-label">
              <span>{{ card.label }}</span>
              <small v-if="card.date" class="summary-date">{{ card.date }}</small>
            </div>
            <div class="summary-number">{{ numberFormatold(card.total) }} <small>{{ card.unit }}</small></div>
          </div>
        </article>
      </section>

      <section class="dashboard-section faculty-section">
        <div class="section-heading">
          <span class="section-icon orange"><i class="ti ti-layout-grid"></i></span>
          <h2>จำนวนเข้าร่วมกิจกรรมแบ่งตามคณะ</h2>
        </div>
        <div class="faculty-grid">
          <article class="faculty-card" v-for="(fac, i) in result_data.fac" :key="'fac' + i">
            <span class="faculty-icon" :style="softColor(fac.color)">
              <img :src="'/static/img/logo/' + fac.fac_logo" />
            </span>
            <div class="faculty-name">{{ fac.name }}</div>
            <div class="faculty-total text-end">{{ numberFormatold(fac.total) }} คน</div>
          </article>
        </div>
      </section>

      <section class="dashboard-section activities-section mt-3">
        <div class="activities-heading">
          <div class="section-heading">
            <span class="section-icon orange"><i class="ti ti-calendar-event"></i></span>
            <h2>รายการกิจกรรม</h2>
          </div>
          <div class="activity-tools">
            <label class="search-box">
              <i class="ti ti-search"></i>
              <input v-model.trim="search" type="search" placeholder="ค้นหาชื่อกิจกรรม...">
            </label>
            <button class="sort-toggle" type="button" @click="toggleWorkshopSort">
              <i :class="sortBy === 'id' ? 'ti ti-list-numbers' : 'ti ti-users'"></i>
              <span>{{ sortBy === 'id' ? 'เรียงปกติ' : 'เรียงตามผู้เข้าร่วม' }}</span>
              <i class="ti ti-arrows-exchange"></i>
            </button>
          </div>
        </div>

        <div class="loading-state" v-if="result_data.workshop.length < 1 && isLoad">
          <div class="spinner-border text-azure" role="status"></div>
        </div>
        <div class="activity-grid" v-else>
          <article class="activity-card" v-for="(ws, i) in displayedWorkshops" :key="'wsc' + i">
            <span class="activity-icon" :style="softColor(ws.fac_color)">
              <img :src="'/static/img/logo/' + ws.fac_logo" :alt="ws.fac_name">
            </span>
            <div class="activity-copy">
              <h3>{{ ws.workshop_name }}</h3>
              <p>{{ ws.fac_name }}</p>
            </div>
            <div class="activity-count">
              <strong>{{ numberFormatold(ws.total) }}</strong>
              <span>ครั้ง</span>
            </div>
          </article>
        </div>
      </section>
    </main>
    <div class="bottom-accent"></div>
  </div>
</template>

<script>
import moment from 'moment'
import Swal from 'sweetalert2'
import api from '../assets/services'

export default {
  name: 'dash',
  data() {
    return {
      dateNow: moment(new Date()).format('YYYY-MM-DD'),
      isLoad: true,
      search: '',
      sortBy: 'id',
      sortDirection: 'asc',
      result_data: {
        user: [{ name: 'ผู้เข้าร่วมทั้งหมด', total: 0 }],
        user_all: 0,
        user_regis: 0,
        fac: [
          { id: '1', name: 'คณะบริหารธุรกิจและศิลปศาสตร์', color: '#2997f5', total: '0' },
          { id: '2', name: 'คณะวิทยาศาสตร์และเทคโนโลยีการเกษตร', color: '#65bd4b', total: '0' },
          { id: '3', name: 'คณะวิศวกรรมศาสตร์', color: '#d82727', total: '0' },
          { id: '4', name: 'คณะศิลปกรรมและสถาปัตยกรรมศาสตร์', color: '#ff8418', total: '0' },
          { id: '5', name: 'วิทยาลัยเทคโนโลยีและสหวิทยาการ', color: '#a991e8', total: '0' }
        ],
        workshop: []
      },
      setTime: ''
    }
  },
  computed: {
    summaryCards() {
      return [
        {
          key: 'all-users',
          label: 'ลงทะเบียนทั้งหมด',
          total: this.userAllTotal,
          unit: 'คน',
          variant: 'summary-orange',
          image: '/static/img/mascot/rmutl-standing.png'
        },
        {
          key: 'today-users',
          label: 'ลงทะเบียน',
          date: this.displayShortDate,
          total: this.userTotal,
          unit: 'คน',
          variant: 'summary-orange',
          image: '/static/img/mascot/rmutl-laptop.png'
        },
        {
          key: 'today-checkin',
          label: 'ลงทะเบียนเข้างาน',
          date: this.displayShortDate,
          total: this.userRegis,
          unit: 'คน',
          variant: 'summary-orange',
          image: '/static/img/mascot/rmutl-heart.png'
        },
        {
          key: 'all-activities',
          label: 'เข้าร่วมกิจกรรม',
          date: this.displayShortDate,
          total: this.workshopTotal,
          unit: 'ครั้ง',
          variant: 'summary-green',
          image: '/static/img/mascot/rmutl-shield.png'
        }
      ]
    },
    userTotal() {
      return this.result_data.user && this.result_data.user[0] ? this.result_data.user[0].total : 0
    },
    userAllTotal() {
      return this.result_data.user_all ? this.result_data.user_all : 0
    },
    userRegis() {
      return this.result_data.user_regis ? this.result_data.user_regis : 0
    },
    displayDate() {
      const months = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
      const value = new Date(this.dateNow + 'T00:00:00')
      return value.getDate() + ' ' + months[value.getMonth()] + ' ' + (value.getFullYear() + 543)
    },
    displayShortDate() {
      const months = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
      const value = new Date(this.dateNow + 'T00:00:00')
      return value.getDate() + ' ' + months[value.getMonth()] + ' ' + (value.getFullYear() + 543)
    },
    sortWorkshop() {
      const direction = this.sortDirection === 'asc' ? 1 : -1
      return this.result_data.workshop.slice().sort((a, b) => {
        const first = Number(this.sortBy === 'id' ? a.id : a.total) || 0
        const second = Number(this.sortBy === 'id' ? b.id : b.total) || 0
        return (first - second) * direction
      })
    },
    filteredWorkshops() {
      const keyword = this.search.toLowerCase()
      if (!keyword) return this.sortWorkshop
      return this.sortWorkshop.filter(ws => {
        return (ws.workshop_name || '').toLowerCase().indexOf(keyword) > -1 ||
          (ws.fac_name || '').toLowerCase().indexOf(keyword) > -1
      })
    },
    displayedWorkshops() {
      return this.filteredWorkshops
    },
    workshopTotal() {
      return this.result_data.fac.reduce((total, fac) => total + (parseInt(fac.total) || 0), 0)
    }
  },
  methods: {
    toggleWorkshopSort() {
      this.setWorkshopSort(this.sortBy === 'id' ? 'total' : 'id')
    },
    setWorkshopSort(field) {
      if (this.sortBy === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
        return
      }

      this.sortBy = field
      this.sortDirection = field === 'id' ? 'asc' : 'desc'
    },
    openDatePicker() {
      const input = this.$refs.dateInput
      if (!input) return

      if (typeof input.showPicker === 'function') {
        input.showPicker()
      } else {
        input.focus()
        input.click()
      }
    },
    facultyIcon(index) {
      return ['ti-users-group', 'ti-leaf', 'ti-settings', 'ti-palette', 'ti-building-community'][index] || 'ti-calendar-event'
    },
    softColor(color) {
      return { color: color || '#ff8418', backgroundColor: (color || '#ff8418') + '18' }
    },
    async getDashboard() {
      clearInterval(this.setTime)
      api.dashboard(
        this.$store.state.URL,
        this.dateNow,
        { headers: { 'Public-Token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiT3BlbiBIb3VzZSBSTVVUTCIsInR5cGUiOiJ3ZWJfYXBpIiwiY3JlYXRlIjoiMjAyMi0wOS0wOSAwOTowOTowOSJ9.s8p__DdvjrhZAJAN0Nc8CVV1TnaGHPvXR7NMg-OSl80' } },
        (result) => {
          this.isLoad = false
          if (result.status === 'SUCCESS') {
            this.result_data = result.data
            this.setTime = setInterval(() => this.getDashboard(), 10000)
          } else {
            this.showLoadError(result.message)
          }
        },
        (error) => {
          this.isLoad = false
          this.showLoadError(JSON.stringify(error))
        }
      )
    },
    showLoadError(message) {
      Swal.fire({
        title: 'ดึงข้อมูล',
        text: 'ไม่สามารถดึงข้อมูล เนื่องจาก' + message,
        icon: 'error',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'ลองใหม่อีกครั้ง',
        denyButtonText: 'ยกเลิก'
      }).then(async result => {
        if (result.isConfirmed) await this.getDashboard()
        else if (result.isDenied) {
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        }
      })
    }
  },
  destroyed() {
    clearInterval(this.setTime)
  },
  async mounted() {
    await this.getDashboard()
  }
}
</script>

<style scoped>
.dashboard-page {
  height: 100vh;
  min-height: 100vh;
  color: #252525;
  background: #fff;
  font-family: "Mitr", sans-serif;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.dashboard-header {
  height: 78px;
  background: linear-gradient(105deg, #1d160f 0%, #352414 43%, #bc711f 100%);
  box-shadow: 0 2px 12px rgba(40, 24, 10, .18);
}

.header-content {
  width: calc(100% - 48px);
  height: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  align-items: center;
  gap: 18px;
  color: #fff;
  font-size: 20px;
}

.brand img {
  width: 76px;
  height: 58px;
  object-fit: contain;
}

.date-picker {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 183px;
  padding: 11px 14px;
  margin: 0;
  border-radius: 10px;
  background: #fff;
  color: #383838;
  font-size: 14px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, .12);
  cursor: pointer;
}

.date-picker input {
  position: absolute;
  width: 1px;
  height: 1px;
  right: 12px;
  bottom: 4px;
  opacity: 0;
  pointer-events: none;
}

.date-picker i {
  margin-left: auto;
  font-size: 19px;
}

.dashboard-content {
  width: calc(100% - 48px);
  margin: 30px auto 42px;
}

.summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 22px;
}

.summary-card {
  min-height: 184px;
  padding: 30px;
  border: 1px solid rgba(80, 80, 80, .07);
  border-radius: 14px;
  display: flex;
  align-items: flex-start;
  position: relative;
  overflow: hidden;
}

.summary-orange {
  background: linear-gradient(115deg, #fff9f3, #fff3e7);
}

.summary-green {
  background: linear-gradient(115deg, #f5fbf3, #eff9eb);
}

.summary-icon,
.faculty-icon,
.activity-icon {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 50%;
}

.summary-icon {
  width: 80px;
  height: 80px;
  margin-right: 32px;
  font-size: 43px;
}

.summary-orange .summary-icon {
  color: #fff;
  background: linear-gradient(145deg, #ffad68, #ffc98f);
}

.summary-green .summary-icon {
  color: #61b64b;
  background: #dff1d9;
}

.summary-copy {
  position: relative;
  z-index: 1;
  padding-top: 10px;
}

.summary-label {
  font-size: 18px;
  color: #454545;
  margin-bottom: 2px;
}

.summary-number {
  font-size: 58px;
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -2px;
}

.summary-number small {
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0;
  margin-left: 8px;
}

.sparkline {
  position: absolute;
  right: 18px;
  bottom: 18px;
  width: 44%;
  height: 96px;
  overflow: visible;
}

.sparkline path {
  fill: none;
  stroke: #ff8218;
  stroke-width: 1.5;
}

.sparkline circle {
  fill: #ff8218;
}

.summary-green .sparkline path {
  stroke: #72c16b;
}

.summary-green .sparkline circle {
  fill: #61b858;
}

.dashboard-section {
  margin-top: 30px;
  padding-top: 2px;
  border-top: 1px solid #ececec;
}

.section-heading {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 76px;
}

.section-heading h2 {
  margin: 0;
  font-size: 19px;
  font-weight: 500;
}

.section-icon {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  border: 1px solid #f0e7de;
  border-radius: 13px;
  font-size: 29px;
}

.section-icon.orange {
  color: #ff8218;
}

.faculty-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

.faculty-card,
.activity-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 11px;
  box-shadow: 0 5px 16px rgba(30, 30, 30, .055);
}

.faculty-card {
  min-height: 142px;
  padding: 21px 18px 14px 73px;
  position: relative;
}

.faculty-icon {
  position: absolute;
  left: 18px;
  top: 42px;
  width: 43px;
  height: 43px;
  font-size: 25px;
}

.faculty-name {
  min-height: 51px;
  font-size: 13px;
  line-height: 1.55;
}

.faculty-total {
  font-size: 25px;
  line-height: 1.05;
}

.faculty-unit {
  font-size: 12px;
  margin-top: 3px;
}

.activities-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.activity-card {
  min-height: 146px;
  padding: 26px 18px 18px 76px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.activity-icon {
  position: absolute;
  left: 18px;
  top: 20px;
  width: 46px;
  height: 46px;
  font-size: 26px;
}

.activity-copy {
  min-height: 82px;
}

.activity-copy h3 {
  margin: 1px 12px 7px 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.55;
}

.activity-copy p {
  margin: 0;
  color: #7e8490;
  font-size: 11px;
  line-height: 1.45;
}

.activity-count {
  position: absolute;
  left: 25px;
  bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}

.activity-count strong {
  font-size: 22px;
  font-weight: 400;
}

.activity-count span {
  margin-top: 5px;
  font-size: 10px;
  color: #777;
}

.faculty-badge {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  border-radius: 2px;
}

.faculty-badge img {
  width: 17px;
  height: 17px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.loading-state {
  min-height: 160px;
  display: grid;
  place-items: center;
  color: #8b8b8b;
}

.bottom-accent {
  width: 110%;
  height: 22px;
  margin-left: -5%;
  margin-top: 0;
  flex: 0 0 auto;
  background: linear-gradient(90deg, #d67c08, #ee9a18 70%, #b86408);
  border-radius: 50% 50% 0 0 / 100% 100% 0 0;
}

@media (max-width: 1000px) {
  .faculty-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .activity-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 760px) {

  .header-content,
  .dashboard-content {
    width: calc(100% - 28px);
  }

  .summary-grid {
    grid-template-columns: 1fr;
  }

  .faculty-grid,
  .activity-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .summary-card {
    min-height: 164px;
    padding: 24px;
  }

  .summary-icon {
    width: 66px;
    height: 66px;
    margin-right: 20px;
    font-size: 34px;
  }

  .summary-number {
    font-size: 48px;
  }
}

@media (max-width: 520px) {
  .dashboard-header {
    height: 68px;
  }

  .brand {
    gap: 8px;
    font-size: 15px;
  }

  .brand img {
    width: 55px;
  }

  .date-picker {
    min-width: auto;
    padding: 9px 11px;
    font-size: 11px;
    gap: 7px;
  }

  .dashboard-content {
    margin-top: 18px;
  }

  .faculty-grid,
  .activity-grid {
    grid-template-columns: 1fr;
  }

  .section-heading h2 {
    font-size: 16px;
  }

  .section-icon {
    width: 52px;
    height: 52px;
  }

  .summary-card {
    padding: 20px;
  }

  .summary-label {
    font-size: 15px;
  }

  .sparkline {
    opacity: .6;
  }
}

/* Dark technology dashboard — 2026 */
.dashboard-page {
  --gold: #f49a09;
  --gold-bright: #ffc443;
  --panel: #171009;
  --panel-soft: #21160d;
  color: #fff;
  background:
    radial-gradient(circle at 76% 11%, rgba(166, 90, 5, .16), transparent 25%),
    radial-gradient(circle at 12% 42%, rgba(116, 63, 2, .13), transparent 30%),
    linear-gradient(115deg, #0b0a08 0%, #171008 52%, #120d08 100%);
  scrollbar-color: #8b5209 #171009;
}

.dashboard-header {
  height: 92px;
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(90deg, rgba(7, 7, 6, .96), rgba(22, 15, 8, .9)),
    radial-gradient(circle at 80% 0, rgba(211, 121, 8, .17), transparent 38%);
  border-bottom: 1px solid rgba(222, 133, 16, .45);
  box-shadow: 0 3px 18px rgba(0, 0, 0, .7);
}

.circuit-header {
  position: absolute;
  left: 32%;
  top: 10px;
  width: 52%;
  height: 68px;
  opacity: .42;
  background:
    radial-gradient(circle, #ffb21b 0 1px, transparent 2px) 0 1px / 82px 23px,
    linear-gradient(90deg, transparent 0 10%, #7a490c 10% 34%, transparent 34% 42%, #7a490c 42% 74%, transparent 74%) 0 12px / 100% 1px no-repeat,
    linear-gradient(135deg, transparent 0 48%, #7a490c 49% 51%, transparent 52%) 0 10px / 55px 27px repeat-x;
}

.header-content {
  width: calc(100% - 34px);
  position: relative;
  z-index: 2;
}

.brand {
  gap: 24px;
  font-size: 22px;
  font-weight: 500;
}

.brand img {
  width: 98px;
  height: 66px;
  padding: 4px 10px;
  border: 1px solid rgba(222, 133, 16, .42);
  border-radius: 16px;
  background: rgba(37, 25, 13, .8);
  filter: drop-shadow(0 0 7px rgba(246, 157, 21, .18));
}

.date-picker {
  min-width: 202px;
  padding: 12px 14px 12px 25px;
  border: 1px solid rgba(237, 142, 15, .72);
  border-radius: 19px;
  background: rgba(35, 24, 14, .82);
  color: #fff;
  font-size: 14px;
  box-shadow: inset 0 0 20px rgba(246, 151, 10, .07), 0 0 16px rgba(0, 0, 0, .28);
}

.date-picker i {
  width: 39px;
  height: 39px;
  margin: -5px -7px -5px auto;
  display: grid;
  place-items: center;
  color: var(--gold-bright);
  border: 1px solid rgba(236, 143, 14, .4);
  border-radius: 12px;
  background: rgba(112, 64, 5, .25);
}

.dashboard-content {
  width: calc(100% - 34px);
  margin: 30px auto 18px;
}

.summary-grid {
  gap: 13px;
}

.summary-card {
  min-height: 159px;
  padding: 27px 24px 22px 120px;
  align-items: flex-start;
  overflow: hidden;
  border: 1px solid rgba(231, 135, 9, .72);
  border-radius: 16px;
  background:
    linear-gradient(135deg, rgba(76, 44, 14, .57), rgba(23, 16, 10, .9) 64%),
    radial-gradient(circle at 92% 50%, rgba(226, 132, 7, .2), transparent 30%);
  box-shadow: inset 0 0 40px rgba(176, 93, 4, .1), 0 7px 22px rgba(0, 0, 0, .25);
}

.summary-card::before {
  content: '';
  position: absolute;
  inset: 10px;
  pointer-events: none;
  border-top: 1px solid rgba(243, 151, 19, .28);
  border-left: 1px solid rgba(243, 151, 19, .28);
  clip-path: polygon(0 0, 100% 0, 100% 86%, 94% 100%, 0 100%);
}

.summary-icon {
  position: absolute;
  left: 26px;
  top: 31px;
  width: 82px;
  height: 82px;
  margin: 0;
  color: #ffc33e !important;
  border: 1px solid #d98a12;
  background: rgba(88, 48, 6, .16) !important;
  box-shadow: inset 0 0 18px rgba(255, 164, 25, .13), 0 0 12px rgba(255, 157, 13, .18);
}

.summary-icon::after {
  content: '';
  position: absolute;
  inset: -8px;
  border: 1px solid rgba(229, 138, 14, .55);
  border-radius: 50%;
}

.summary-copy {
  padding-top: 2px;
}

.summary-label {
  color: #fff;
  font-size: 17px;
}

.summary-number {
  color: #fff;
  font-size: 59px;
  text-shadow: 0 0 13px rgba(255, 178, 55, .14);
}

.summary-number small {
  color: #fff;
  font-size: 14px;
}

.sparkline {
  right: 20px;
  bottom: 20px;
  width: 45%;
  height: 82px;
  filter: drop-shadow(0 0 6px #f3980d);
}

.sparkline path,
.summary-green .sparkline path {
  stroke: #ffb222;
  stroke-width: 1.4;
}

.sparkline circle,
.summary-green .sparkline circle {
  fill: #fff2a5;
  stroke: #ffab16;
  stroke-width: 2;
}

.dashboard-section {
  margin-top: 14px;
  padding-top: 0;
  border-top: 1px solid rgba(205, 119, 11, .35);
  position: relative;
}

.dashboard-section::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 32%;
  height: 38px;
  opacity: .32;
  border-top: 1px solid #b2680a;
  transform: skewX(-40deg);
  pointer-events: none;
}

.section-heading {
  min-height: 54px;
  gap: 13px;
  position: relative;
  z-index: 1;
}

.section-heading h2 {
  color: #fff;
  font-size: 18px;
}

.section-icon {
  width: 59px;
  height: 51px;
  color: #ffc044 !important;
  border-color: rgba(224, 133, 13, .68);
  border-radius: 13px;
  background: linear-gradient(135deg, rgba(73, 43, 13, .7), rgba(22, 15, 9, .8));
  box-shadow: inset 0 0 15px rgba(235, 139, 11, .09);
}

.faculty-grid {
  gap: 10px;
}

.faculty-card {
  min-height: 126px;
  padding: 19px 12px 12px 68px;
  color: #fff;
  border-color: rgba(202, 119, 13, .52);
  border-radius: 10px;
  background: linear-gradient(145deg, rgba(52, 35, 18, .88), rgba(25, 18, 12, .96));
  box-shadow: inset 0 0 24px rgba(255, 150, 16, .045), 0 5px 15px rgba(0, 0, 0, .25);
}

.faculty-icon {
  left: 17px;
  top: 33px;
  width: 42px;
  height: 42px;
  border: 1px solid currentColor;
  background-color: transparent !important;
  box-shadow: 0 0 13px rgba(240, 147, 22, .12);
}

.faculty-name {
  min-height: 48px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}

.faculty-total {
  color: #fff;
  font-size: 27px;
}

.faculty-unit {
  color: #fff;
}

.activities-section {
  margin-top: 18px;
  padding: 0 5px 6px;
  border: 1px solid rgba(191, 108, 6, .35);
  border-radius: 13px;
}

.activities-heading {
  min-height: 55px;
  padding: 0 4px;
}

.activity-tools {
  display: flex;
  gap: 10px;
  position: relative;
  z-index: 2;
}

.search-box {
  width: 269px;
  height: 39px;
  margin: 0;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 11px;
  color: #e3c49c;
  border: 1px solid rgba(213, 125, 11, .5);
  border-radius: 16px;
  background: rgba(26, 18, 11, .72);
}

.search-box input {
  width: 100%;
  color: #fff;
  border: 0;
  outline: 0;
  background: transparent;
  font: inherit;
  font-size: 12px;
}

.search-box input::placeholder {
  color: #baa78e;
}

.activity-grid {
  gap: 6px;
}

.activity-card {
  min-height: 130px;
  padding: 20px 13px 14px 69px;
  color: #111;
  border: 1px solid #dba148;
  border-radius: 9px;
  background: linear-gradient(120deg, #fff 0%, #fffefd 70%, #f8efe3 100%);
  box-shadow: 0 0 12px rgba(232, 140, 13, .32);
}

.activity-icon {
  left: 13px;
  top: 16px;
  width: 45px;
  height: 45px;
  border: 1px solid currentColor;
  background-color: transparent !important;
}

.activity-copy {
  min-height: 76px;
}

.activity-copy h3 {
  color: #111;
  font-size: 12px;
  line-height: 1.45;
}

.activity-copy p {
  color: #737373;
  font-size: 10px;
}

.activity-count {
  left: 28px;
  bottom: 12px;
  color: #111;
}

.activity-count strong {
  font-size: 19px;
}

.faculty-badge {
  top: 9px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 3px;
}

.bottom-accent {
  width: 100%;
  height: 105px;
  margin: 0;
  position: relative;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background:
    radial-gradient(ellipse at 76% 100%, rgba(255, 171, 28, .7) 0 1px, transparent 2px),
    linear-gradient(165deg, transparent 0 68%, rgba(146, 76, 4, .38) 69% 71%, transparent 72%),
    linear-gradient(173deg, transparent 0 72%, #d67b08 73% 74%, transparent 75%),
    linear-gradient(177deg, transparent 0 79%, #ffb424 80% 81%, transparent 82%),
    linear-gradient(180deg, rgba(25, 16, 8, .4), #120c07);
}

.bottom-accent::before {
  content: '';
  position: absolute;
  right: -5%;
  top: 4px;
  width: 52%;
  height: 70px;
  opacity: .55;
  background:
    radial-gradient(circle, #ffc343 0 1px, transparent 2px) 0 0 / 70px 24px,
    linear-gradient(135deg, transparent 47%, #8a510b 48% 50%, transparent 51%) 0 0 / 58px 31px repeat-x;
}

@media (max-width: 760px) {

  .header-content,
  .dashboard-content {
    width: calc(100% - 20px);
  }

  .brand {
    gap: 9px;
    font-size: 16px;
  }

  .brand img {
    width: 69px;
    height: 55px;
    border-radius: 11px;
  }

  .date-picker {
    min-width: 153px;
    padding-left: 13px;
  }

  .activity-tools {
    width: 100%;
    margin-bottom: 9px;
  }

  .search-box {
    width: 100%;
  }

  .activities-heading {
    align-items: stretch;
    flex-direction: column;
  }
}

@media (max-width: 520px) {
  .dashboard-header {
    height: 76px;
  }

  .brand strong {
    max-width: 105px;
    line-height: 1.15;
  }

  .date-picker {
    min-width: 126px;
    font-size: 10px;
  }

  .date-picker i {
    width: 30px;
    height: 30px;
  }

  .summary-card {
    padding-left: 94px;
  }

  .summary-icon {
    left: 20px;
    width: 62px;
    height: 62px;
    font-size: 31px;
  }

  .summary-label {
    font-size: 14px;
  }

  .summary-number {
    font-size: 48px;
  }
}

/* Warm ivory dashboard — reference layout */
.dashboard-page {
  --brown: #6f3511;
  --amber: #c88612;
  --line: #ead9c4;
  height: 100vh;
  color: #21140d;
  background:
    radial-gradient(circle at 8% 14%, rgba(190, 126, 38, .045), transparent 22%),
    linear-gradient(115deg, #fffdfa, #fff 52%, #fdf9f2);
  scrollbar-color: #c78a37 #f7eee2;
}

.dashboard-header {
  height: 107px;
  overflow: hidden;
  border: 0;
  background:
    radial-gradient(circle at 67% 10%, rgba(236, 174, 72, .19), transparent 27%),
    linear-gradient(104deg, #2a160b 0%, #4a2916 44%, #8c5726 100%);
  box-shadow: 0 3px 13px rgba(53, 28, 11, .18);
}

.dashboard-header::after {
  content: '';
  position: absolute;
  left: 61%;
  top: -22px;
  width: 210px;
  height: 140px;
  opacity: .3;
  transform: rotate(-8deg);
  background:
    radial-gradient(ellipse at center, transparent 0 29%, #d49a38 30% 31%, transparent 32% 40%, #d49a38 41% 42%, transparent 43%),
    conic-gradient(from 20deg, transparent, rgba(222, 161, 60, .55), transparent 28%, rgba(222, 161, 60, .35), transparent 62%);
  border-radius: 50%;
}

.circuit-header {
  display: none;
}

.header-content {
  width: calc(100% - 68px);
}

.brand {
  gap: 20px;
}

.brand img {
  width: 64px;
  height: 75px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  filter: drop-shadow(0 3px 5px rgba(0, 0, 0, .22));
}

.brand-copy {
  padding-left: 20px;
  border-left: 1px solid rgba(240, 194, 116, .62);
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.brand-copy strong {
  color: #fff;
  font-size: 25px;
  line-height: 1.1;
  font-weight: 500;
}

.brand-copy small {
  color: rgba(255, 255, 255, .88);
  font-size: 12px;
  font-weight: 300;
}

.date-picker {
  min-width: 256px;
  height: 51px;
  padding: 0 15px 0 27px;
  color: #39200f;
  border: 1px solid rgba(123, 69, 20, .25);
  border-radius: 9px;
  background: linear-gradient(110deg, #f4ca7b, #ffe4ad);
  box-shadow: 0 4px 13px rgba(36, 17, 6, .13);
  font-size: 16px;
}

.date-picker i {
  width: auto;
  height: auto;
  margin: 0 0 0 auto;
  color: #74400d;
  border: 0;
  border-radius: 0;
  background: transparent;
  font-size: 22px;
}

.dashboard-content {
  width: calc(100% - 66px);
  margin: 21px auto 30px;
}

.summary-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 21px;
}

.summary-card {
  min-height: 129px;
  padding: 22px 22px 18px 149px;
  color: #24150d;
  border: 1px solid #e8d5bd;
  border-radius: 13px;
  background:
    linear-gradient(105deg, rgba(255, 255, 255, .98), rgba(255, 252, 247, .92)),
    radial-gradient(circle at 84% 50%, rgba(216, 157, 57, .13), transparent 30%);
  box-shadow: 0 4px 12px rgba(79, 45, 18, .07);
}

.summary-card:nth-child(1) {
  border-color: #ead1a8;
  background: linear-gradient(120deg, #fffdf8 0%, #fff3d9 100%);
}

.summary-card:nth-child(2) {
  border-color: #bdd9c4;
  background: linear-gradient(120deg, #fbfefb 0%, #dff1e3 100%);
}

.summary-card:nth-child(3) {
  border-color: #ebc8be;
  background: linear-gradient(120deg, #fffdfc 0%, #fce5df 100%);
}

.summary-card:nth-child(4) {
  border-color: #c6dde0;
  background: linear-gradient(120deg, #fbfefe 0%, #deeff0 100%);
}

.summary-card::before {
  display: none;
}

.summary-icon {
  left: 26px;
  top: 17px;
  width: 85px;
  height: 85px;
  color: #fff !important;
  padding: 9px;
  overflow: hidden;
  border: 1px solid rgba(164, 99, 25, .28);
  background: linear-gradient(135deg, #fff8e8, #f4d79f) !important;
  box-shadow: 0 5px 12px rgba(91, 52, 18, .12);
}

.summary-icon img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  position: relative;
  z-index: 1;
  transform: scale(.86);
  transform-origin: center;
}

.summary-card:nth-child(2) .summary-icon {
  border-color: #afd0b7;
  background: linear-gradient(135deg, #f5fcf6, #cce6d2) !important;
}

.summary-card:nth-child(3) .summary-icon {
  border-color: #edc1b4;
  background: linear-gradient(135deg, #fff5f1, #f8cec2) !important;
}

.summary-card:nth-child(4) .summary-icon {
  border-color: #bcd9df;
  background: linear-gradient(135deg, #f2fbfc, #cce8ea) !important;
}

.summary-icon::after {
  display: none;
}

.summary-copy {
  max-width: calc(100% - 44px);
  padding-top: 0;
}

.summary-card-art {
  position: absolute;
  z-index: 0;
  right: -12px;
  bottom: -45%;
  width: 46%;
  height: 150%;
  object-fit: contain;
  object-position: right bottom;
  opacity: .11;
  pointer-events: none;
  filter: sepia(.12);
}

.summary-label {
  color: #24150d;
  font-size: 18px;
}

.summary-date {
  margin-left: 6px;
  color: #76583e;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}

.summary-number {
  color: #24150d;
  font-size: 57px;
  text-shadow: none;
  line-height: 1;
}

.summary-number small {
  color: #24150d;
  font-size: 16px;
}

.sparkline {
  right: 23px;
  bottom: 20px;
  width: 36%;
  height: 78px;
  filter: drop-shadow(0 8px 9px rgba(213, 145, 19, .18));
}

.sparkline path,
.summary-green .sparkline path {
  stroke: #bd7907;
  stroke-width: 1.7;
}

.sparkline circle,
.summary-green .sparkline circle {
  fill: #d59a2a;
  stroke: #b87508;
  stroke-width: 1;
}

.dashboard-section {
  margin-top: 13px;
  padding: 0 16px 14px;
  border: 1px solid #eadfce;
  border-radius: 14px;
  background: rgba(255, 255, 255, .38);
  box-shadow: 0 3px 10px rgba(91, 54, 20, .035);
}

.dashboard-section::after {
  display: none;
}

.section-heading {
  min-height: 61px;
  gap: 18px;
}

.section-heading h2 {
  color: #26180f;
  font-size: 18px;
}

.section-icon {
  width: 46px;
  height: 46px;
  color: #a75b0a !important;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  font-size: 31px;
}

.faculty-grid {
  gap: 32px;
}

.faculty-card {
  min-height: 121px;
  padding: 20px 12px 12px 89px;
  color: #20140d;
  border: 1px solid #e9dac7;
  border-radius: 10px;
  background: rgba(255, 255, 255, .7);
  box-shadow: 0 3px 9px rgba(75, 43, 17, .045);
}

.faculty-icon {
  left: 14px;
  top: 20px;
  width: 60px;
  height: 60px;
  border: 0;
  background-color: transparent !important;
  box-shadow: none;
  font-size: 32px;
}

.faculty-icon::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: currentColor;
  opacity: .08;
}

.faculty-name {
  min-height: 47px;
  color: #20140d;
  font-size: 12px;
  text-align: left;
  line-height: 1.4;
}

.faculty-total {
  color: #20140d;
  font-size: 25px;
}

.faculty-unit {
  color: #20140d;
  font-size: 11px;
}

.activities-section {
  margin-top: 0;
  padding: 0 16px 14px;
  border-color: #eadfce;
  border-radius: 14px;
}

.activities-heading {
  min-height: 64px;
  padding: 0;
}

.activity-tools {
  gap: 16px;
}

.sort-toggle {
  min-width: 190px;
  min-height: 44px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  border: 1px solid #a6671a;
  border-radius: 10px;
  background: linear-gradient(135deg, #7b4217, #bd7c24);
  box-shadow: 0 3px 8px rgba(99, 55, 20, .18);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.search-box {
  width: 294px;
  height: 44px;
  padding: 0 17px;
  color: #774920;
  border: 1px solid #e1d3c2;
  border-radius: 11px;
  background: rgba(255, 255, 255, .76);
}

.search-box input {
  color: #27180e;
  font-size: 13px;
}

.search-box input::placeholder {
  color: #8f7b69;
}

.activity-grid {
  grid-template-columns: repeat(4, 1fr);
  gap: 13px 18px;
}

.activity-card {
  min-height: 128px;
  padding: 16px 13px 12px 83px;
  color: #17100b;
  border: 1px solid #e8dbc9;
  border-radius: 9px;
  background: rgba(255, 255, 255, .78);
  box-shadow: 0 3px 9px rgba(71, 42, 19, .045);
}

.activity-icon {
  left: 13px;
  top: 17px;
  width: 55px;
  height: 55px;
  border: 0;
  background-color: transparent !important;
  font-size: 30px;
}

.activity-icon::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: currentColor;
  opacity: .09;
}

.activity-icon i {
  position: relative;
  z-index: 1;
}

.activity-icon img {
  position: relative;
  z-index: 1;
  display: block;
  width: 72%;
  height: 72%;
  object-fit: contain;
}

.activity-copy {
  min-height: 82px;
  padding-right: 28px;
}

.activity-copy h3 {
  margin-right: 0;
  color: #17100b;
  font-size: 12.5px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.activity-copy p {
  color: #766d66;
  font-size: 10.5px;
  line-height: 1.35;
}

.activity-count {
  left: 15px;
  bottom: 10px;
  color: #21150e;
  flex-direction: row;
  gap: 4px;
}

.activity-count strong {
  font-size: 17px;
}

.activity-count span {
  margin: 0;
  color: #756a60;
}

.faculty-badge {
  top: 0;
  right: 7px;
  width: 27px;
  height: 35px;
  border-radius: 0;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% 82%, 0 100%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, .15);
}

.faculty-badge img {
  width: 15px;
  height: 15px;
  margin-top: -5px;
}

.bottom-accent {
  display: none;
}

@media (max-width: 1200px) {
  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .activity-grid {
    grid-template-columns: repeat(4, 1fr);
  }

  .faculty-grid {
    gap: 14px;
  }
}

@media (max-width: 900px) {
  .activity-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .faculty-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .brand-copy small {
    display: none;
  }
}

@media (max-width: 760px) {
  .summary-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-header {
    height: 82px;
  }

  .header-content,
  .dashboard-content {
    width: calc(100% - 24px);
  }

  .brand img {
    width: 54px;
    height: 58px;
  }

  .brand-copy {
    padding-left: 10px;
  }

  .brand-copy strong {
    font-size: 17px;
  }

  .date-picker {
    min-width: 158px;
    height: 43px;
    padding-left: 13px;
    font-size: 12px;
  }

  .activity-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .activity-tools {
    margin-bottom: 10px;
    flex-wrap: wrap;
  }

  .sort-toggle {
    width: 100%;
  }
}

@media (max-width: 520px) {
  .brand-copy {
    display: none;
  }

  .date-picker {
    min-width: 145px;
  }

  .dashboard-content {
    margin-top: 12px;
  }

  .summary-card {
    padding-left: 98px;
    min-height: 120px;
  }

  .summary-icon {
    left: 17px;
    width: 65px;
    height: 65px;
    font-size: 35px;
  }

  .summary-label {
    font-size: 14px;
  }

  .summary-number {
    font-size: 45px;
  }

  .faculty-grid,
  .activity-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-section {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue